const Config = {
  autoplay: false,
  loadLive2d: true
};

export default Config;